<template>
    <div>
        <b-modal
            :modal-class="modalClass"
            v-model="modalShow"
            :okTitle="okTitle || $t('COMMON.BUTTON.CAMEL.OK')"
            :cancelTitle="cancelTitle || $t('COMMON.BUTTON.CAMEL.CANCEL')"
            :cancel-variant="btnCancelStyle"
            :ok-only="isOKOnly"
            :ok-variant="btnOkStyle"
            :title="title"
            :ok-disabled="isOkDisabled"
            :size="modalSize"
            @cancel="cancelFunction"
            @ok="okFunction"
            @hide="callOnHide"
        >
            <div class="body-message">
                <slot name="body-message">
                    <p> {{ message }} </p>
                </slot>
            </div>
            <div class="body-template">
                <slot name="body-template">
                    <!--template-->
                </slot>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {BModal} from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css"

export default {
    name: "Modal",
    components: {BModal},
    data() {
        return {
            modalShow: false
        }
    },
    props: {
        modalSize: String,
        modalClass: {
            type: String,
            default: ""
        },
        okTitle: String,
        cancelTitle: String,
        btnCancelStyle: {
            type: String,
            default: "light"
        },
        btnOkStyle: {
            type: String,
            default: "primary"
        },
        title: {
            type: String,
            default: "Modal Title"
        },
        isOKOnly: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: "Modal message"
        },
        okFunction: {
            type: Function,
            default: () => {
                console.log("Function was not implemented")
            }
        },
        cancelFunction: {
            type: Function,
            default: () => {return null}
        },
        callOnHide: {
            type: Function,
            default: () => {}
        },
        isShowPopup: {
            type: Boolean,
            default: false
        },
        isOkDisabled: {
            isOkDisabled: Boolean,
            default: false
        }
    },
    watch: {
        isShowPopup(newVal, oldVal) {
            this.modalShow = newVal;
        }
    },
    methods: {
        showPopup() {
            this.modalShow = true;
        }
    }
}
</script>

<style lang="scss" scoped>

/deep/ .modal-dialog {
    /*/default width is 500px/*/
    width: 400px;
    font-family: 'Noto Sans Korean', serif;
}

/deep/ .default-modal .modal-dialog {
    width: inherit;
}

/deep/ .modal-dialog.modal-lg {
    min-width: 600px;
}

/deep/ .modal-header {
    height: 48px;
    padding: 0;
}

/deep/ .modal-content {
    border-radius: 0;
}

/deep/ .modal-body {
    min-height: 90px;
    font-size: 14px;
}

/deep/ .modal-header .close {
    position: absolute;
    right: 12px;
    font-size: 16px;
    padding: 4px;
    text-align: center;
    margin: 10px 0;
    color: #7e8793;
}

/deep/ .modal-title {
    width: 100%;
    text-align: center;
    height: 26px;
    font-family: 'Noto Sans Korean', serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.63;
    padding: 11px;
    color: var(--darkgray-1);
}

/deep/ .modal-footer button {
    border-radius: 4px !important;
    min-width: 75px;
}
/deep/ button.btn.btn-light:hover,
    button.btn.btn-light:focus {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5;
}
/deep/ .modal-footer button.btn.btn-primary.disabled {
    color: #fff !important;
    background-color: #71b6ffc2 !important;
    border-color: #71b6ffc2 !important;
}
/deep/ input[type=checkbox] {
    -webkit-appearance:checkbox;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modals/Modal.vue